import { InternalScheduleHeaderPendingProps } from './types';

export const InternalScheduleHeaderPending = ({
  dateControl,
}: InternalScheduleHeaderPendingProps) => (
  <div aria-busy className="grid grid-cols-[auto_auto] items-center gap-x-6 gap-y-1">
    {dateControl}
    <div className="h-8 w-[229px] animate-pulse rounded bg-neutral-100" />
    <div className="flex justify-center">
      <div className="my-0.5 h-[18px] w-36 animate-pulse rounded bg-neutral-100" />
    </div>
    <div className="min-h-6" />
  </div>
);
